import { useQuery } from '@tanstack/react-query'
import { api } from '@api'

export type UnipileService = 'instagram' | 'whatsapp' | 'linkedin' | 'gmail'

export interface UnipileAccountItem {
  id: string
  service: UnipileService | string
  provider: string
  status: string
}

interface UnipileAccountsResponse {
  accounts: UnipileAccountItem[]
  count: number
}

const fetchUnipileAccounts = async (): Promise<UnipileAccountsResponse> => {
  const { data } = await api.get<UnipileAccountsResponse>('/ft_unipile/accounts')
  return data
}

export const useUnipileAccounts = (enabled: boolean = true) =>
  useQuery<UnipileAccountsResponse>({
    queryKey: ['ft_unipile_accounts'],
    queryFn: fetchUnipileAccounts,
    enabled,
  })
